import { systemLanguages } from 'src/environments/environment';

export const getValidLanguage = (language: string | undefined): string => {
  if (!language) return 'en';

  const browserLang = language.toLowerCase();
  const supportedLanguage = systemLanguages.find(
    (lang: any) => lang.language.toLowerCase() === browserLang || browserLang.startsWith(lang.language.toLowerCase()),
  );

  return supportedLanguage ? supportedLanguage.language : 'en';
};
